<template>
  <div class="discussPage">
    <Header></Header>
    <div class="bannerWrap">
      <div class="mainTit">
        <span class="active">供需平台</span>
      </div>
      <div class="sunTit">
        / Supply and demand platform

      </div>
    </div>
    <div class="content">
      <div class="tabMenu">
        <span :class="{'active':type==1}" @click="changeType(1)">需求大厅</span>
        <span :class="{'active':type==2}" @click="changeType(2)">服务大厅</span>
      </div>
      <div class="tabBar">
        <div class="tabName" :class="{'active': ptIndex === idx}" v-for="(item, idx) in list" :key="idx" @click="changeData(idx, item.id)">{{item.name}}</div>
      </div>
      <div class="tabBody">
        <div class="tabWrap" v-for="(item, index) in list" :key="item.name" :class="{'active': ptIndex === index}">
          <div class="cItem" v-for="(item, idx) in content" :key="idx">
            <div style="width: 100%;">
              <div class="cItemTit">{{item.name}}</div>
              <div class="cItemText">{{item.createTime}}</div>
              <div class="cItemText">{{item.details}}</div>
            </div>
            <div class="myBtn" @click="goDetail(item.id)">查看详情 ➞</div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import {
    categoryList,
    supplyDemandList
  } from '@/api/api'
  export default {
    data() {
      return {
        type: 1, //供需1、服务2tab
        ptIndex: 0, // 分类Tab
        content: [],
        list:[
          {
            tabName:'全部',
          },
          {
            tabName:'设备制造业',
          },
          {
            tabName:'化工行业',
          },
        ]
      }
    },
    components: {
      Header,
      Footer
    },
    mounted() {
      if(this.$route.params.type) {
        this.type = parseInt(this.$route.params.type)
      }
      this.getCategoryList()
    },
    methods: {
     changeType(type) {
       this.type = type
       this.ptIndex = 0
       this.getCategoryList()
     },
     getSupplyDemandList(id) {
       supplyDemandList({
         type: this.type,
         categoryId: id ? id : ''
       }).then(res => {
         console.log(JSON.stringify(res))
         this.content = res.data.content
       })
     },
     getCategoryList() {
       categoryList().then(res => {
         this.list = res.data
         this.list.unshift({
           id: 0,
           name: "全部"
         })
         this.getSupplyDemandList(this.list[0].id)
       })
     },
     changeData(idx, id) {
       this.ptIndex = idx
       this.getSupplyDemandList(id)
     },
     goDetail(id) {
       this.$router.push({
         path: '/DiscussDetails',
         query: {
           data: id,
           type: this.type, // 1需求大厅 2服务大厅
         },
       })
     }
    }
  }
</script>

<style scoped>
.discussPage{
}
.bannerWrap{
  width: 100%;
  height: 480px;
  background: url('../../assets/images/discussBanner.png') top center no-repeat;
  background-size: 100% 100%;
  padding: 265px 0 0 60px;
  box-sizing: border-box;
}
.mainTit{
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #346392;
  margin-bottom: 44px;
  cursor: pointer;
}
.mainTit span.active{
  color: #fff;
}
.sunTit{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
}
.content{
  width: 1300px;
  margin: 0 auto 50px;
  padding-top: 100px;
}
.tabBar{
  border-bottom: 1px solid #DADFE7;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.tabName{
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #909DB1;
  padding: 0 18px 14px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  position: relative;
  top: 1px;
  margin-right: 20px;
}
.tabName:hover{
  color: #0F5EFF;
  border-bottom: 2px solid #0F5EFF;
}
.tabName.active{
  color: #0F5EFF;
  border-bottom: 2px solid #0F5EFF;
}
.cItem{
  border-bottom: 1px dashed #DADFE7;
  padding-top: 56px;
  padding-bottom: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cItemTit{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #121E30;
  padding-bottom: 20px;
}
.cItemText{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #516381;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
  width: 90%;
  /* border: 1px solid #f00; */
}
.myBtn{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #909DB1;
  padding: 7px 15px;
  border: 2px solid #909DB1;
  border-radius: 25px;
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
  width: 120px;
}
.myBtn:hover{
  color: #0F5EFF;
  border: 2px solid #0F5EFF;
}
.tabWrap{
  display: none;
}
.tabWrap.active{
  display: block;
}
.tabMenu{
  width: 416px;
  height: 54px;
  border: 2px solid #ECEEF2;
  border-radius: 26px;
  margin: 0 auto 80px;
  display: flex;
  box-sizing: border-box
}
.tabMenu span{
  display: inline-block;
  width: 50%;
  height: 52px;
  text-align: center;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #909DB1;
  border-radius: 26px;
  line-height: 52px;
  cursor: pointer;
}
.tabMenu span.active{
  background: #0F5EFF;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/platform/Discuss.vue